import { ISide } from '../types/fast-game';

type IGame = { white: { id: string }; black: { id: string } };

export function getSides(
  playerId?: string,
  data?: IGame,
): { playerSide: ISide; opponentSide: ISide } {
  const playerSide = getPlayerSide(playerId, data);
  const opponentSide = playerSide === 'none' ? 'none' : playerSide === 'white' ? 'black' : 'white';

  return { playerSide, opponentSide };
}

function getPlayerSide(playerId?: string, data?: IGame): ISide {
  if (playerId === data?.white.id) return 'white';
  if (playerId === data?.black.id) return 'black';
  return 'none';
}
